import { Documentation } from 'graphql-common';
import { AttachmentValue } from '@lib/components/FileUploaderUppy/FileUploaderUppy';
import getAttachmentMeta from './getAttachmentMeta';

/**
 * True when a Documentation's current-version attachment is a video. Used to
 * pick the "Marked as watched" vs "Marked as read" success toast.
 */
const isVideoDocumentation = (doc?: Documentation | null): boolean => {
  const attachment = doc?.currentVersion?.attachmentAttached;
  if (!attachment) return false;
  return getAttachmentMeta(attachment as AttachmentValue).mimeType.startsWith(
    'video',
  );
};

export default isVideoDocumentation;
